export default "__VITE_ASSET__BVKcIgyg__"